<template>
  <div
    data-component="success"
    v-tiled-background-image="$store.getters['ui/getBackgroundImage']"
  >
    <div data-element="success-header">
      <h3
        data-element="success-heading"
        v-font-style="this.$store.getters['ui/getHeadingFontDetail']"
        v-color="this.$store.getters['ui/getPrimaryColor']"
        v-modify-leading="this.$store.getters['ui/getHeadingFontDetail']"
        :style="{ fontSize: '20px' }"
      >
        Payment successful!
      </h3>
    </div>
    <p
      data-element="text-top"
      class="heading"
      data-size="sm"
      data-weight="bold"
      v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('normal')"
    >
      Thank you for your order.
    </p>
    <p
      data-element="text-top"
      class="heading"
      data-size="sm"
      data-weight="bold"
      v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('normal')"
    >
      We've emailed you your receipt.
    </p>
    <template v-if="!collectOnly">
      <p
        data-element="text-bottom"
        class="heading"
        data-size="sm"
        data-weight="bold"
        v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('normal')"
      >
        Your order will be served soon to table:
      </p>
      <p
        data-element="table-number"
        v-font-style="$store.getters['ui/getBodyCopyFontDetail']('normal')"
        :style="{ fontSize: '30px' }"
      >
        {{ tableNumber }}
      </p>
    </template>
    <template v-else>
      <p
        data-element="text-bottom"
        class="heading"
        data-size="sm"
        data-weight="bold"
        v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('normal')"
      >
        Your order number is:
      </p>
      <p
        data-element="table-number"
        v-font-style="$store.getters['ui/getBodyCopyFontDetail']('normal')"
        :style="{ fontSize: '30px' }"
      >
        {{ orderNumber }}
      </p>
    </template>
    <div
      data-element="center-heading"
      v-font-style="this.$store.getters['ui/getHeadingFontDetail']"
      v-color="this.$store.getters['ui/getPrimaryColor']"
      v-modify-leading="this.$store.getters['ui/getHeadingFontDetail']"
      :style="{ fontSize: '20px' }"
    >
      Order details
    </div>
    <div data-element="order-details-container">
      <table data-element="order-details">
        <tr data-element="order-details-row" v-if="orderRef">
          <td
            data-element="label"
            v-font-style="
              this.$store.getters['ui/getBodyCopyFontDetail']('light')
            "
          >
            {{ collectOnly ? 'Receipt' : 'Order' }} ID:
          </td>
          <td
            data-element="order-detail"
            class="medium"
            v-font-style="
              this.$store.getters['ui/getBodyCopyFontDetail']('light')
            "
          >
            {{ orderRef }}
          </td>
        </tr>
        <tr data-element="order-details-row" v-if="orderTime">
          <td
            data-element="label"
            v-font-style="
              this.$store.getters['ui/getBodyCopyFontDetail']('light')
            "
          >
            Order Time
          </td>
          <td
            data-element="order-detail"
            class="medium"
            v-font-style="
              this.$store.getters['ui/getBodyCopyFontDetail']('light')
            "
          >
            {{ orderTime }}
          </td>
        </tr>
      </table>

      <div data-element="show-details-container">
        <div data-element="show-details" @click="toggleDetail">
          <p
            data-element="text"
            v-font-style="
              this.$store.getters['ui/getBodyCopyFontDetail']('light')
            "
          >
            {{ expanded ? "Less" : "More" }} details
          </p>
          <icon
            icon="collapse-arrow"
            size="xs"
            data-element="icon"
            :class="{ rotated: expanded }"
          />
        </div>
      </div>

      <transition name="expand">
        <div data-element="more-details" v-if="expanded">
          <div data-element="basket">
            <line-item
              v-for="(lineItem, index) in lineItems"
              data-element="line-item"
              :getProduct="getProduct"
              :key="`${index}-lineItem`"
              :lineItem="lineItem"
              :hideIncrementor="true"
              :hideEditChoices="true"
              :showQuantity="true"
              :fullWidth="true"
            />
          </div>
          <div data-element="order-cost">
            <span
              data-element="basket-qty"
              v-font-style="
                this.$store.getters['ui/getBodyCopyFontDetail']('light')
              "
            >
              {{ basketLengthCopy }}
            </span>
            <table data-element="cost-breakdown">
              <tr>
                <td
                  class="label"
                  v-font-style="
                    this.$store.getters['ui/getBodyCopyFontDetail']('light')
                  "
                >
                  Total amount:
                </td>
                <td
                  v-font-style="
                    this.$store.getters['ui/getBodyCopyFontDetail']('light')
                  "
                >
                  £{{ total | fixedPrice }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </transition>
      <dynamic-link
        data-element="terms-link"
        text="Terms and conditions"
        size="xs"
        :link="true"
        href="/terms"
      />
    </div>
  </div>
</template>

<script>
import DynamicLink from "@/components/ui/DynamicLink";
import Icon from "@/components/ui/Icon";
import LineItem from "@/components/basket/LineItem";

export default {
  components: {
    DynamicLink,
    Icon,
    LineItem,
  },
  data() {
    return {
      expanded: false,
    };
  },
  props: [
    "orderRef",
    "orderTime",
    "lineItems",
    "getProduct",
    "total",
    "buttonLink",
    "buttonText",
    "basketCount",
    "toggleModal",
    "tableNumber",
    "orderNumber",
    "collectOnly",
  ],
  computed: {
    basketLengthCopy() {
      const qty = this.basketCount;
      if (qty === 1) return `${qty} Item`;
      else return `${qty} Items`;
    },
  },
  methods: {
    toggleDetail() {
      this.expanded = !this.expanded;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
@import "@/assets/scss/helpers.scss";

[data-component="success"] {
  display: flex;
  justify-content: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0 100px;
  [data-element="success-heading"] {
    margin-bottom: 16px;
  }
  [data-element="text-top"],
  [data-element="text-bottom"] {
    margin-bottom: 16px;
    padding: 0 16px;
    width: 100%;
    @include whenScreenIs(sm) {
      max-width: 448px;
    }
  }
  [data-element="text-top"] {
    &:first-of-type {
      margin-bottom: 0;
    }
  }
  [data-element="phone-link"] {
    display: block;
    margin-top: 8px;
    [data-element="phone-link"] {
      text-decoration: none;
    }
  }
  [data-element="table-number"] {
    margin-bottom: 24px;
  }
  [data-element="center-heading"] {
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px;
    font-size: 20px;
    font-weight: bold;
    line-height: 1.2;
    text-align: center;
    @include whenScreenIs(sm) {
      margin-top: 24px;
    }
  }
  [data-element="order-details-container"] {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 16px 16px 0;
    width: 100%;
    [data-element="order-details"] {
      margin-top: 4px;
      width: 100%;
      font-size: 16px;
      font-weight: 400;
      [data-element="order-details-row"] {
        height: 32px;
        [data-element="label"] {
          width: 120px;
        }
        [data-element="order-detail"] {
          text-align: right;
        }
      }
      .bold {
        font-weight: bold;
      }
      .medium {
        font-weight: 700;
      }
      .light {
        font-size: 13px;
        font-weight: 500;
        width: 130px;
      }
    }
    [data-element="order-ahead-details"] {
      width: 100%;
    }
    [data-element="show-details-container"] {
      width: 100%;
      display: flex;
      border-bottom: 1px solid #d8d8d8;
      [data-element="show-details"] {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        margin-top: 10px;
        cursor: pointer;
        [data-element="icon"] {
          -webkit-transition: all 0.5s ease-in-out;
          -o-transition: all 0.5s ease-in-out;
          transition: all 0.5s ease-in-out;
          &.rotated {
            -webkit-transform: rotate(180deg);
            -ms-transform: rotate(180deg);
            -o-transform: rotate(180deg);
            transform: rotate(180deg);
          }
        }
        [data-element="text"] {
          margin-right: 5px;
          font-weight: 700;
          font-size: 16px;
          padding-left: 2px;
        }
      }
    }
    [data-element="more-details"] {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      overflow: hidden;
      opacity: 1;
      transition: 0.5s linear;
      &.expand-enter-active,
      &.expand-leave-active {
        max-height: 999px;
        opacity: 0;
      }
      &.expand-enter, &.expand-leave-to /* .list-leave-active below version 2.1.8 */ {
        max-height: 0;
        opacity: 0;
      }
      [data-element="order-details"] {
        margin-bottom: 18px;
      }
      [data-element="basket"] {
        width: 100%;
        [data-element="line-item"] {
          width: 100%;
        }
      }
      [data-component="email-confirmation"] {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 8px;
        width: 100%;
        &[data-cancel] {
          align-items: left;
        }
        [data-element="message"] {
          font-size: 13px;
          font-weight: 500;
          line-height: 1.23;
          padding-top: 8px;
        }
        [data-element="information"] {
          font-size: 16px;
          font-weight: 100;
          padding: 8px 0 16px;
          [data-element="email"] {
            font-weight: bold;
          }
        }
      }
      [data-element="order-cost"] {
        width: 100%;
        margin: 16px 0;
        font-size: 16px;
        font-weight: 600;
        display: flex;
        text-align: right;
        justify-content: space-between;

        [data-element="cost-breakdown"] {
          .discount {
            td {
              padding-top: 8px;
              font-size: 13px;
            }
          }
          td.label {
            text-align: left;
            font-weight: 500;
            width: 125px;
          }
        }
      }
    }
    [data-element="terms-link"] {
      margin: 10px 0;
    }
  }
  [data-element="sharing-container"] {
    display: flex;
    justify-content: center;
    background-color: $white;
    padding: 12px 5px;
    margin: 16px;
    @include whenScreenIs(sm) {
      margin: 16px 0;
    }
    [data-element="text"] {
      width: 216px;
      text-align: left;
      @include whenScreenIs(sm) {
        margin-bottom: 0px;
      }
    }
    [data-element="share-button"] {
      display: block;
      text-align: center;
      width: 88px;
      color: $jungle-green;
      background-color: $white;
      font-family: $font;
      font-size: 18px;
      padding: 6px 16px;
      font-weight: 700;
      border: 2px solid $jungle-green;
      &:hover,
      &:active {
        cursor: pointer;
        background-color: $jungle-green;
        color: #fff;
      }
    }
  }
  [data-element="bottom-button-container"] {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    padding: 8px 16px;
    width: 100%;
    @include whenScreenIs(sm) {
      margin-top: 40px;
    }
  }
}
</style>
